import Link from 'next/link';
import { Button, ButtonBallColor, Url } from '../types';
import Ball from '../icon/Ball';
import ColoredBall from '../icon/ColoredBall';

interface MenuLinkProps {
  name: string;
  url?: Url;
  textSize?: string;
  textColor?: string;
  styles?: string;
  transparentBg?: boolean;
  backgroundColor?: string;
  border?: boolean;
  width?: string;
  buttonStyle?: Button['buttonStyle'] | undefined;
  buttonBallColor?: ButtonBallColor;
}

export default function ButtonLink({
  name,
  url,
  styles,
  transparentBg,
  backgroundColor,
  border = true,
  textSize = 'text-sm',
  textColor,
  width,
  buttonStyle,
  buttonBallColor,
}: MenuLinkProps) {
  const widthStyle = width ? width : 'w-fit';
  let bgColor = transparentBg
    ? 'bg-transparent hover:bg-transparent'
    : 'bg-white hover:bg-slate-200';

  if (backgroundColor) {
    bgColor = backgroundColor;
  }

  const borderColor = transparentBg
    ? 'hover:bg-white/20 hover:border-white/40'
    : 'border-zinc-200 hover:border-slate-200';
  const borderStyles = border ? 'border rounded-r-full rounded-l-full' : 'border-0 shadow-none';
  const forcedStyles = `${transparentBg ? 'border-white border-opacity-40' : ''} ${textSize} ${bgColor} font-bold ${borderStyles} ${borderColor} ${styles}`;

  if (!url)
    return (
      <div
        className={`group flex ${widthStyle} mx:20 items-center justify-center gap-2 ${transparentBg && !border ? 'py-4' : 'px-6 py-4'} ${styles} ${forcedStyles}`}
      >
        {name}
        <BallType buttonStyle={buttonStyle} />
      </div>
    );

  const linkUrl = url.slug ? `${url.url}${url.slug}` : url.url;
  const linkTarget = url.external ? '_blank' : '_self';

  return (
    <Link
      href={linkUrl}
      prefetch={false}
      className={`group-hover flex items-center justify-center gap-2 ${textColor} ${forcedStyles} group ${widthStyle} ${transparentBg && !border ? 'py-4' : 'px-6 py-4'} `}
      tabIndex={0}
      target={linkTarget}
    >
      {name}
      {!backgroundColor && <BallType buttonStyle={buttonStyle} buttonBallColor={buttonBallColor} />}
    </Link>
  );
}

const BallType = ({
  buttonStyle,
  buttonBallColor,
}: {
  buttonStyle: MenuLinkProps['buttonStyle'];
  buttonBallColor?: ButtonBallColor;
}) => {
  return (
    <span className="group-hover:animate-bounce">
      {buttonStyle === 'transparent_with_ball' ? (
        <ColoredBall color={buttonBallColor} />
      ) : (
        <Ball animated={true} />
      )}
    </span>
  );
};
